import React, { Component, useContext } from 'react';
import styled from 'styled-components';
import { DnDContext } from '../DnDContext';
import moment from 'moment-timezone'
import Droppable2 from './Droppable2'
const Container = styled.div`
    height: 100%;
    flex-grow: 4;
    display: grid;
    /* border: ${props => !props.isHeader && '1px solid yellow'}; */
`

class TimeSlotWrapper extends Component {
    static contextType = DnDContext;

    render() {
        const {
            children,
            resource,
            value,
            key
        } = this.props;
        const { draggable, slotHandlers, extraProps } = this.context
        const isHeader = this.props.resource === undefined
        const id = `CALENDAR_${moment(value).format('YYYY-MM-DD HH:mm')}`
        // !isHeader && console.log({ isHeader, id: moment(value).format('YYYY-MM-DD HH:mm') })
        
        const ref = this.context['extraProps']['refs'][value.getHours()]
        return (
            <Container key={id} 
                ref={ref} 
                isHeader={isHeader}>
                {isHeader ? children
                : <Droppable2 id={id} boundingRect={ref.current && ref.current.getBoundingClientRect()} extraProps={extraProps}>
                    {children}
                </Droppable2>}
            </Container>
        )
    }
}

export default TimeSlotWrapper
